import { sortWith, ascend, prop, find, propEq } from "ramda";
import { formatAnswer } from "./formatAnswer";

/**
 * 把作答中的原始狀態轉成交卷要送的「顯示文字」格式。
 *
 * 原始狀態：選擇題是布林陣列 [false, true, false]、配合題是選項序號 3。
 * 伺服器的批改只認顯示文字（"FALSE"、"iii"），所以交卷前一定要先轉。
 *
 * 交卷（ConfirmFinish / TestResult）和自動存檔都用這一支——
 * 2026-10-18 的事故就是自動存檔存了原始狀態、伺服器時間到結算時直接拿去批改，
 * 選擇題與配合題全部判錯。同一個函式轉出來的東西，兩條路不可能不一樣。
 */
export const buildSubmitAnswers = (testType, answerKey, storedAnswers, testPages) => {
  if (testType === "W") {
    return [...storedAnswers];
  }

  const qustionIdSort = sortWith([ascend(prop("questionId"))]);
  const KEYS = qustionIdSort(answerKey);
  const answers = qustionIdSort(storedAnswers);

  const formatedAnswers = [];
  KEYS.forEach((KEY) => {
    const questionId = KEY.questionId;
    const answer = find(propEq("questionId", questionId))(answers);
    const formatedAnswer = formatAnswer(testPages, KEY, answers);
    if (answer === undefined) {
      formatedAnswers.push({
        questionId,
        answer: formatedAnswer,
      });
      return;
    }

    formatedAnswers.push({
      ...answer,
      answer: formatedAnswer,
    });
  });
  return formatedAnswers;
};
